import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

const EmrDetails = (props) => {
  const { pat_id } = useParams();

  const [rows, setRows] = useState([]);
 
  const [patientData, setPatientData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response1 = await axios.get(`${baseUrl}pat-id/${pat_id}/`);
        if (response1.status === 200 || response1.status === 201) {
          setPatientData(response1.data);
          const patId = response1.data[0].id;
          const response2 = await axios.get(`${baseUrl}emr-lab-op/${patId}/`);
          const labData = response2.data.map((data) => ({ ...data, type: 'lab' }));
          const response3 = await axios.get(`${baseUrl}emr-inv-op/${patId}/`);
          const invData = response3.data.map((data) => ({ ...data, type: 'inv' }));
          
          const uniqueIds = new Set();
          labData.forEach((data) => uniqueIds.add(data.appt_id));
          invData.forEach((data) => uniqueIds.add(data.appt_id));

          const combined = [
            ...labData.filter((data) => uniqueIds.has(data.appt_id)),
            ...invData.filter((data) => uniqueIds.has(data.appt_id)),
          ];
          setRows(combined);
        } else {
          window.location.href = '/pat-search/';
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [pat_id]);


  const columns = [
    { field: 'add_date', headerName: 'Appt Date', width: 120 },
    { field: 'appt_id', headerName: 'Appt Id', width: 200 },
    {
      field: 'test_name',
      headerName: 'Test Name',
      width: 600,
      renderCell: (params) => {
        const data = params.row || {};
        if (data.type === 'lab') {
          return data.lab_test;
        } else {
          return data.inv_test;
        }
      }
    },

        { field: 'addedby', headerName: 'Added by', width: 100 },
    {
    field: 'action',
    headerName: 'Action',
    renderCell: (params) => (
      <Link
        to={
          params.row.type === 'lab'
            ? `/lab-report-all/${params.row.appt_id}/`
            : params.row.type === 'inv'
            ? `/inv-report-all/${params.row.appt_id}/`            
            : ''
        }
        className="btn btn-success"
      >
        {params.row.type === 'lab' ? 'Lab' : 'Inv'}
      </Link>
    ),
    width: 100,
  },
  ];

      


  return (
    <section className="container mt-4">
      <div className="row table-responsive">
        <div className="col-md-12 col-12 mb-2">
          <table className="table table-bordered table-hover " style={{ borderColor: '#1bc5ce' }}>
            <thead>
              <tr style={{ backgroundColor: '#1bc5ce', color: 'white' }}>
                <th>Patient ID</th>
                <th>Patient Name</th>
                <th>Gender</th>
                <th>D.O.B/Age</th>
                <th>Mobile</th>
                <th>Regd. On</th>
              </tr>
            </thead>
            <tbody>
              {patientData.map((patientData, index) => (
                <tr key={index}>
                  <td>{patientData.pat_id}</td>
                  <td>{patientData.patient}</td>
                  <td>{patientData.gender}</td>
                  <td>{patientData.age}</td>
                  <td>{patientData.mobile}</td>
                  <td>{patientData.add_date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        </div>
          <div style={{ height: "100%", width: '100%' }}>
          <h3 className="text-center" style={{color: 'black', backgroundColor: '#e5eaef'}}><i className="fa-solid fa-calendar-days"
            aria-hidden="true" style={{color: 'red'}}></i> OP EMR Details</h3>
            <DataGrid
              className="mt-4"
              sx={{
                boxShadow: 4,
                border: 4,
                borderColor: 'primary.light',
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
              }}
              
              rows={rows}
              columns={columns}
              pageSize={10}
              slots={{ toolbar: GridToolbar }}
              autoHeight
            />
          </div>
      
    </section>
  );
};

export default EmrDetails;
